export enum TrackBidPlacedPrebidStatus {
    Leading = 'Leading',
    NoBid = 'No Bid',
    Outbid = 'Outbid',
    ReserveNotMet = 'Reserve Not Met',
}
